module.exports = __webpack_public_path__ + "static/media/title-lion-deco.ed337878.png";